import React, { useState, useMemo } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Upload, Button, message } from 'antd';
import fileUpload from '@/pages/activity-manage/merchants/venue-detail/apis.js';

export default (props) => {
  const { value = {}, onChange } = props;
  const [loading, setLoading] = useState(false);
  const activityIntroFile = useMemo(() => {
    if (!value || !value.activityIntroUrl || !value.activityIntroName || !value.fileUrl) return [];
    return [{ name: value.activityIntroName, url: value.fileUrl }];
  }, [value]); // 活动详情文件

  const upload = (e) => {
    const file = e.file;
    const formData = new FormData();
    formData.append('file', file);
    setLoading(true);
    fileUpload
      .fileUpload(formData)
      .then((res) => {
        setLoading(false);
        const { ret } = res;
        if (ret === '0' && res.data) {
          onChange({
            introName: res.data.files[0].name,
            introUrl: res.data.files[0].key,
            // fileUrl: res.data.files[0].url,
          });
          message.success('上传成功');
        } else {
          message.error(res.msg);
        }
      })
      .catch((err) => {
        message.error(err);
      });
  };
  return (
    <div className="actRoom-collect-detail-upload">
      {value.introName && <a style={{ marginRight: 8 }}>{value.introName}</a>}
      <Upload
        accept=".doc,.docx,.rar,.zip"
        customRequest={upload}
        maxCount={1}
        name="collect-detail"
        fileList={activityIntroFile}
        beforeUpload={(file) => {
          return new Promise(function (resolve, reject) {
            if (
              !file.name.endsWith('.doc') &&
              !file.name.endsWith('.docx') &&
              !file.name.endsWith('.rar') &&
              !file.name.endsWith('.zip')
            ) {
              message.error('文件类型不符合');
              return reject(new Error('文件类型不符合'));
            }
            if (file.zise > 20 * 1024 * 1024) {
              message.error('文件大小不符合规范,要求为20MB以内');
              return reject(new Error('文件大小不符合规范,要求为20MB以内'));
            }
            return resolve();
          });
        }}
        onRemove={() => {
          onChange('');
        }}
      >
        <Button type="primary" loading={loading} icon={<UploadOutlined />}>
          {value.introName ? '重新上传' : '上传文件'}
        </Button>
      </Upload>
      <div className="tip">支持20MB以内；支持word文档及压缩包</div>
    </div>
  );
};
